'use client'

import clsx from 'clsx'

import { Icon } from '@wartek-id/icon'
import { ListItem } from '@wartek-id/list'
import { Text } from '@wartek-id/text'

interface SelectionItemProps {
  testId: string
  onClick?: () => void
  selected: boolean
  tail?: boolean
  reverse?: boolean
  text: string
}

export function SelectionItem({
  testId,
  selected = false,
  tail = false,
  text,
  onClick,
  reverse = false,
}: SelectionItemProps) {
  return (
    <ListItem
      className={clsx('cursor-pointer', selected ? 'bg-surface-subdued' : '')}
      iconLeft={reverse ? <Icon>keyboard_arrow_left</Icon> : null}
      iconRight={
        selected && !tail && !reverse ? <Icon>keyboard_arrow_right</Icon> : null
      }
      onClick={onClick}
      data-testid={testId}
    >
      <Text variant={selected ? 'body-bold' : 'body'}>{text}</Text>
    </ListItem>
  )
}
